import { PackEditorTabMode } from 'enums';
import { FocusModeTemplateType } from 'interfaces/common.interface';
import { SettingsType } from 'interfaces/setting.interface';
import { compareSettings } from 'utils/validators';

export interface HasPackEditorUnsavedChangesArgs {
  packEditorTabMode: PackEditorTabMode | null;
  currentSettings: SettingsType;
  initialCurrentViewedPack: SettingsType | null;
  currentViewedFocusTemplate: FocusModeTemplateType | null;
  initialCurrentViewedFocusTemplate: FocusModeTemplateType | null;
}

export const hasPackEditorUnsavedChanges = ({
  packEditorTabMode,
  currentSettings,
  initialCurrentViewedPack,
  currentViewedFocusTemplate,
  initialCurrentViewedFocusTemplate
}: HasPackEditorUnsavedChangesArgs): boolean => {
  if (
    packEditorTabMode === PackEditorTabMode.ROUTINE ||
    packEditorTabMode === PackEditorTabMode.STANDALONE
  ) {
    return compareSettings(currentSettings, {
      ...currentSettings,
      ...initialCurrentViewedPack
    });
  }

  if (
    packEditorTabMode === PackEditorTabMode.FOCUS_MODE &&
    initialCurrentViewedFocusTemplate
  ) {
    return compareSettings(
      currentViewedFocusTemplate ?? {},
      initialCurrentViewedFocusTemplate
    );
  }

  return false;
};
